import { ModeHero } from "./ModeHero";
import { DrillCard } from "./DrillCard";
import { Divider } from "./Divider";
import { PrepProgress, type SessionMode } from "../welcome/PrepProgress";
import { useT } from "../../lib/use-t";

type DrillMode = {
  id: Exclude<SessionMode, "full">;
  num: number;
  labelKey: string;
  subKey: string;
  durationKey: string;
};

// Reuses the existing modePicker.drill.* i18n keys (same Deel labels/subs).
const DRILLS: DrillMode[] = [
  { id: "deel-1", num: 1, labelKey: "modePicker.drill.deel1Label", subKey: "modePicker.drill.deel1Sub", durationKey: "oefenen.spreken.duration.deel-1" },
  { id: "deel-2", num: 2, labelKey: "modePicker.drill.deel2Label", subKey: "modePicker.drill.deel2Sub", durationKey: "oefenen.spreken.duration.deel-2" },
  { id: "deel-3", num: 3, labelKey: "modePicker.drill.deel3Label", subKey: "modePicker.drill.deel3Sub", durationKey: "oefenen.spreken.duration.deel-3" },
  { id: "deel-4", num: 4, labelKey: "modePicker.drill.deel4Label", subKey: "modePicker.drill.deel4Sub", durationKey: "oefenen.spreken.duration.deel-4" },
];

type Props = {
  selected: SessionMode;
  onSelect: (m: SessionMode) => void;
  disabled: boolean;
  pending: boolean;
  done: boolean;
};

export function SprekenModeBody({ selected, onSelect, disabled, pending, done }: Props) {
  const t = useT();
  return (
    <div className="space-y-4">
      <ModeHero
        selected={selected === "full"}
        onSelect={() => onSelect("full")}
        disabled={disabled}
        eyebrow={t("oefenen.spreken.heroEyebrow")}
        title={t("oefenen.spreken.heroTitle")}
        description={t("oefenen.spreken.heroDescription")}
      />

      <Divider label={t("oefenen.divider.spreken")} />

      <div className="grid grid-cols-2 gap-3">
        {DRILLS.map((d) => (
          <DrillCard
            key={d.id}
            num={d.num}
            title={t(d.labelKey)}
            subtitle={t(d.subKey)}
            duration={t(d.durationKey)}
            selected={selected === d.id}
            onSelect={() => onSelect(d.id)}
            disabled={disabled}
          />
        ))}
      </div>

      {pending ? <PrepProgress mode={selected} done={done} /> : null}
    </div>
  );
}
